import jwt from 'jsonwebtoken';
import api from '../api';
import { getCookie } from './cookies';

// const dataIndividual = require('../../data/dataIndividual.json');
const dataGeneral = require('../../data/dataGeneral.json');

const {
  VUE_APP_EVENTID,
  VUE_APP_HOURID,
  VUE_APP_API_URL,
  VUE_APP_API_PLATFORM,
  VUE_APP_VISANET_JS,
  VUE_APP_VISANET_ID,
  VUE_APP_MASTERCARD_JS,
  VUE_APP_DINERS_JS,
  VUE_APP_AMEX_JS,
  VUE_APP_PROCESOS_ID,
  VUE_APP_GOOGLE_SITE_KEY,
} = process.env;

const formatTwo = (n) => (n > 9 ? `${n}` : `0${n}`);

export default {
  data() {
    return {
      // eslint-disable-next-line
      ...dataGeneral,
      eventId: VUE_APP_EVENTID,
      hourId: VUE_APP_HOURID,
      projectKey: 'joinnus-prime',
      isPackage: true,
      apiUrl: VUE_APP_API_URL,
      apiNode: `${VUE_APP_API_PLATFORM}/endpoints`,
      siteKey: VUE_APP_GOOGLE_SITE_KEY,
      jsVisanet: VUE_APP_VISANET_JS,
      visanetMerchantId: VUE_APP_VISANET_ID,
      jsProcesosMastercard: VUE_APP_MASTERCARD_JS,
      jsProcesosDiners: VUE_APP_DINERS_JS,
      jsProcesosAmex: VUE_APP_AMEX_JS,
      procesosPagoMerchantId: VUE_APP_PROCESOS_ID,
      events: [],
    };
  },
  computed: {
    session() {
      return this.$store.state.auth.token;
    }
  },
  methods: {
    getMetadataVal(eventData, key) {
      const res = eventData.metadata.find((el) => el.key === key);
      if (res) {
        return res.charValue;
      }
      return false;
    },
    messageToastButton(variant = 'default', title = 'Mensaje', message, buttonMessage, buttonClick) {
      const h = this.$createElement;

      if (buttonMessage) {
        const $closeButton = h(
          'b-button',
          {
            class: ['btn-outline-dark btn-sm rounded-pill px-2 py-0 my-1'],
            style: 'background: #e35d6a; margin-left: 4px',
            on: {
              click: () => this.$router.push(buttonClick),
            },
          },
          buttonMessage,
        );
        // Create the toast
        this.$bvToast.toast([message, $closeButton], {
          title,
          variant,
          toaster: 'b-toaster-bottom-center',
          solid: true,
          appendToast: true,
          autoHideDelay: 10000,
        });
      }
    },
    async eventsData(slug) {
      const events = await api.getData();
      const eventSelected = events.find((e) => e.slug === `${slug.toLowerCase()}`);
      if (this.events && this.events.length === 0) {
        this.events = events;
      }
      return eventSelected;
    },
    async eventsDataMobile(eventId) {
      const events = await api.getData();
      const eventSelected = events.find((e) => e.eventId === parseInt(eventId, 0));
      return eventSelected;
    },
    async eventList() {
      const events = await api.getData();
      const obj = {};
      events.forEach((e) => {
        obj[e.slug] = { ...e };
      });
      this.events = obj;
      return events;
    },
    messageToast(variant = 'default', title = 'Mensaje', message) {
      this.$bvToast.toast(message, {
        title,
        variant,
        toaster: 'b-toaster-bottom-center',
        solid: true,
        appendToast: true,
        autoHideDelay: 10000,
      });
    },
    signToken(payload) {
      return jwt.sign(payload, 'jnputin', { noTimestamp: true });
    },
    dateFriend(date) {
      if (!date) return '';
      const months = [
        'enero',
        'febrero',
        'marzo',
        'abril',
        'mayo',
        'junio',
        'julio',
        'agosto',
        'setiembre',
        'octubre',
        'noviembre',
        'diciembre',
      ];
      const patrs = date.split('-');
      let poer = patrs[2].split('T');
      if (typeof poer[1] === 'undefined') {
        poer = patrs[2].split(' ');
      }
      return `${poer[0]} de ${months[parseInt(patrs[1], 0) - 1]} ${patrs[0]} | ${this.parseHourString(poer[1])}`;
    },
    formatSimpleDate(_date, { hours } = {}) {
      const date = new Date(_date);
      if (hours) date.setHours(hours);
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      return date.toLocaleDateString('es-PE', options);
    },
    fotmatToHour(date) {
      date = new Date(date);
      return date.toLocaleTimeString('es-PE', { timeStyle: 'short' });
    },
    hourFriend(hour) {
      const patrs = hour.split('-');
      return `${this.parseHourString(patrs[0])} - ${this.parseHourString(patrs[1])}`;
    },
    parseHourString(time) {
      const patrs = time.split(':');
      let ampm = ' AM';
      if (patrs[0] >= 12) {
        ampm = ' PM';
      }
      if (patrs[0] > 12) {
        patrs[0] -= 12;
      }
      const formattedTime = `${formatTwo(parseInt(patrs[0], 0))}:${patrs[1]}${ampm}`;
      return formattedTime;
    },
    getDateHours(date) {
      const d = new Date(date);
      const day = `${d.getDate()}`.padStart(2, '0');
      const month = `${d.getMonth()}`.padStart(2, '0');
      let hours = d.getHours();
      const ampm = hours >= 12 ? 'pm' : 'am';
      hours = hours === 12 ? 12 : `${hours % 12}`.padStart(2, '0');
      const minutes = `${d.getMinutes()}`.padStart(2, '0');
      const hour = `${hours}:${minutes} ${ampm}`;
      const result = `${day}/${month}/${d.getFullYear()} - ${hour}`;
      return result;
    },
    getFieldMeta(arr, key, defaultValue) {
      const search = arr.find((el) => el.key === key);
      if (search) return search.charValue;
      return defaultValue ? defaultValue.default : '[]';
    },
    round(numb) {
      if (!numb) return '';
      return Number(numb).toFixed(2);
    },
    textUpperCase(text) {
      if (!text) return '';
      return text.toUpperCase(2);
    },
    includesEvents(value) {
      const eventList = this.events;
      const eventArr = eventList.map((e) => e.slug);
      return eventArr ? eventArr.includes(value) : [];
    },
    reload() {
      window.location.reload();
    },
    toLC(value) {
      if (!value) return '';
      return value.toLowerCase();
    },
    async addMarkers(slugPartner) {
      const response = await api.getMarkersJSON();
      const markerList = response.find((e) => e.slug === slugPartner);
      if (markerList) {
        const markingList = markerList.marking;
        const gtm = markingList.find((e) => e.key === 'GTM');
        if (gtm) this.addTagManager(gtm);
      }
    },
    verifyCookie() {
     const existCookie = getCookie('consentCookies');
      let isVerifyAnalytics = false;
      if (existCookie) {
        const cookie = JSON.parse(existCookie);
        isVerifyAnalytics = cookie.some((c) => c.key === 'cookie_administration' && c.isChecked);
      }
      return isVerifyAnalytics;
    },
    loadAnalytics() {
      const gtmId = 'GTM-PZLTD9';
      this.addTagManager(gtmId, true);
    },
    addTagManager(googleTagManagerT, isLocal) {
      if (this.verifyCookie() && document) {
        const head = document.getElementsByTagName('head')[0];
        const body = document.getElementsByTagName('body')[0];
        let googleTagManager = null;
        if (googleTagManagerT) {
          googleTagManager = isLocal ? googleTagManagerT : googleTagManagerT.value;
          const script = document.createElement('script');
          script.id = isLocal ? 'tagManager' : 'tagManagerPartner';
          script.textContent = this.googleManager(googleTagManager);
          head.appendChild(script);
          const noscript = document.createElement('noscript');
          noscript.id = isLocal ? 'nsTagManager' : 'nsTagManagerPartner';
          const iframe = document.createElement('iframe');
          iframe.src = `https://www.googletagmanager.com/ns.html?id=${googleTagManager}`;
          iframe.height = '0';
          iframe.width = '0';
          iframe.style.display = 'none';
          iframe.style.visibility = 'hidden';
          noscript.appendChild(iframe);
          body.appendChild(noscript);
        }
      }
    },
    googleManager(gtmId) {
      return `(function(w,d,s,l,i){w[l]=w[l]||[];
      w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});
      var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
      j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${gtmId}');
      `;
    },
    hotJar() {
      return `
      (function(h,o,t,j,a,r){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        h._hjSettings={hjid:3553215,hjsv:6};
        a=o.getElementsByTagName('head')[0];
        r=o.createElement('script');r.async=1;
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
        a.appendChild(r);
      })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
      `;
    },
    addHotJar() {
      const head = document.getElementsByTagName('head')[0];
      let existHotJar = null;
      if (typeof window !== 'undefined') existHotJar = window.document.getElementById('hotJar');
      if (!existHotJar && this.verifyCookie()) {
        const script = document.createElement('script');
        script.id = 'hotJar';
        script.textContent = this.hotJar(existHotJar);
        head.appendChild(script);
      }
    },
    addFacebookPixel(pixelId, idName) {
      if (!document.getElementById(idName) && this.verifyCookie()) {
        const head = document.getElementsByTagName('head')[0];
        const script = document.createElement('script');
        script.id = idName;
        const scriptText = this.scriptActivate(pixelId);
        const parser = new DOMParser();
        const doc = parser.parseFromString(scriptText, 'text/html');
        script.appendChild(doc.body.firstChild);
        const noscript = document.createElement('noscript');
        noscript.id = `${idName}NS`;
        const image = document.createElement('img');
        image.height = '1';
        image.width = '1';
        image.style.display = 'none';
        image.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1?v=${this.hash}`;
        noscript.appendChild(image);
        head.appendChild(script);
        head.appendChild(noscript);
      }
    },
    scriptActivate(id) {
      return `!function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${id}');
      fbq('track', 'PageView');
      `;
    },
    tagPixel(gaId) {
      return `
      window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', '${gaId}');
      `;
    },
    scriptTagPixel(id) {
      const head = document.getElementsByTagName('head')[0];
      const script = document.createElement('script');
      script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
      script.async = true;
      head.appendChild(script);
      const script2 = document.createElement('script');
      script2.textContent = this.tagPixel(id);
      head.appendChild(script2);
    }
  },
};
